const Technology = ({ name }) => {
    return (
        <div class="bg-white shadow-md py-2 md:px-8 px-4 md:rounded-none rounded-xl">
            {name}
        </div>
    )
}

export default Technology